export const SOFTLINE_FEATURE_INVENTUR = 'inventur';

export const SOFTLINE_PERMISSION_INVENTUR = 'SOFTAPPS.LAGER.INVENTUR';
